import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '../../css/home/article_content.scss';
import $ from "jquery";
import Swiper from 'swiper';
import { Pagination, Navigation, A11y } from 'swiper/modules';

//components
import '../share/components/_footnotes.js';
import { font_size_fn } from "../share/components/_fontSize.js";

$(function() {

    font_size_fn();

    //swiper ------------------------------------------
    let $swiper;
    let swiper_el;
    let container;
    let pagination;
    let button_next;
    let button_prev;
    let _tpl;
    let _slidesPerView;

    if ($(".media_swiper").length > 0) {

        $(".media_swiper").each(function(i, o) {
            _tpl = $(o).data('template');
            _slidesPerView = _tpl == 3 ? 2 : 1;
            swiper_el = '#' + $(o).attr('id');
            container = swiper_el + ' .swiper';
            pagination = swiper_el + ' .swiper-pagination';
            button_next = swiper_el + ' .swiper-button-next';
            button_prev = swiper_el + ' .swiper-button-prev';
            $swiper = new Swiper(container, {
                modules: [Pagination, Navigation, A11y],
                grabCursor: true,
                slidesPerView: _slidesPerView,
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                navigation: {
                    nextEl: button_next,
                    prevEl: button_prev,
                },
                a11y: {
                    enabled: true,
                    firstSlideMessage: "第一則",
                    lastSlideMessage: "最後一則",
                    paginationBulletMessage: "到第 {{index}} 則",
                },
            });
        });
    }
});